// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { DEFAULT_NUMBER_ONE, EMPTY_STRING, MAX_SIZE_FILE_UPLOAD, REG_EXP } from '~/utils/constants/common';
import { IFormSendGmail } from '~/utils/interface/google';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      files: yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().trim().optional(),
            name: yup.string().trim().optional(),
            url: yup.string().trim().optional(),
            file: yup
              .mixed<File>()
              .optional()
              .test('fileSize', t('common_validate_file_size', { ns: 'common/base' }), (value) => {
                if (!value) return true;
                if (value && value?.size <= MAX_SIZE_FILE_UPLOAD) return true;
                return false;
              }),
          })
        )
        .optional(),
      content: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      subject: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      to: yup
        .array()
        .of(
          yup
            .string()
            .trim()
            .required(t('common_validate_field_required', { ns: 'common/base' }))
            .email(t('common_validate_invalid_email', { ns: 'common/base' }))
            .matches(REG_EXP.EMAIL, t('common_validate_invalid_email', { ns: 'common/base' }))
        )
        .min(DEFAULT_NUMBER_ONE, t('common_validate_field_required', { ns: 'common/base' }))
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      cc: yup
        .array()
        .of(
          yup
            .string()
            .required()
            .email(t('common_validate_invalid_email', { ns: 'common/base' }))
            .matches(REG_EXP.EMAIL, t('common_validate_invalid_email', { ns: 'common/base' }))
        )
        .optional(),
      bcc: yup
        .array()
        .of(
          yup
            .string()
            .required()
            .email(t('common_validate_invalid_email', { ns: 'common/base' }))
            .matches(REG_EXP.EMAIL, t('common_validate_invalid_email', { ns: 'common/base' }))
        )
        .optional(),
    })
    .required();
};

export const defaultValuesForm: IFormSendGmail = {
  content: EMPTY_STRING,
  subject: EMPTY_STRING,
  to: [],
  cc: [],
  bcc: [],
  files: [],
};
